import App from '../../app';

const AMPLITUDE_EVENT_NAME = "Pageview: Admin";

export default function AdminController($scope, gettextCatalog) {

  'ngInject';

  $scope.title = "Admin";

  var menuItems = [{
    "title": gettextCatalog.getString("Users"),
    "sref": "admin.userslist",
    "icon": "fas fa-users"
  }, {
    "title": gettextCatalog.getString("Security Groups"),
    "sref": "admin.securitygroups",
    "icon": "fas fa-users"
  }, {
    "title": gettextCatalog.getString("Manage Invites"),
    "sref": "admin.manageinvites",
    "icon": "fa fa-briefcase"
  }, {
    "title": gettextCatalog.getString("User Roles"),
    "sref": "admin.usersRoleslist",
    "icon": "fas fa-users"
  }];

  $scope.menuItems = menuItems;

  $scope.isActiveState = function (state) {
    return true;
  };

  this.$onInit = () => {
    App.amplitude.track(AMPLITUDE_EVENT_NAME);
  }
}